import { StrictMode, createElement } from 'react'
import type { ReactElement } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/main.scss'
import App from './App.tsx'
import Chatbot from './components/Chatbot'
import type { ChatbotProps } from './types'

// Global type declaration
declare global {
  interface Window {
    OneAIChatbot: {
      init: (containerId: string, props: ChatbotProps) => ReturnType<typeof createRoot> | null;
      createElement: typeof createElement;
      render: (element: ReactElement, container: HTMLElement) => ReturnType<typeof createRoot>;
      Chatbot: typeof Chatbot;
    };
  }
}

// For standalone mode
if (typeof document !== 'undefined' && document.getElementById('root')) {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

// For library/widget usage
export { Chatbot as default }
export { Chatbot}
export type { ChatbotProps, ChatMessage, ChatSession } from './types'

// Global function for embedding
if (typeof window !== 'undefined') {
  window.OneAIChatbot = {
    init: (containerId: string, props: ChatbotProps) => {
      const container = document.getElementById(containerId)
      if (container) {
        const root = createRoot(container)
        root.render(
          <StrictMode>
            <Chatbot {...props} />
          </StrictMode>
        )
        return root
      }
      return null
    },
    createElement,
    render: (element: ReactElement, container: HTMLElement) => {
      const root = createRoot(container)
      root.render(element)
      return root
    },
    Chatbot,

  }
}
